import { useEffect, useRef, useState } from 'react';

const useHover = ({ delay = 300, query } = { delay: 300 }) => {
  const [element, setElement] = useState(null);
  const ref = useRef(null);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return () => {};
    }

    let timeout;
    const handleMouseEnter = event => {
      timeout = setTimeout(() => {
        setElement(event.target);
      }, delay);
    };
    const handleMouseLeave = () => {
      clearTimeout(timeout);
      setElement(null);
    };

    const nodes = query ? node.querySelectorAll(query) : [node];
    nodes.forEach(n => n.addEventListener('mouseenter', handleMouseEnter));
    nodes.forEach(n => n.addEventListener('mouseleave', handleMouseLeave));
    return () => {
      nodes.forEach(n => n.removeEventListener('mouseenter', handleMouseEnter));
      nodes.forEach(n => n.removeEventListener('mouseleave', handleMouseLeave));
      clearTimeout(timeout);
    };
  }, [delay, query]);
  return [ref, element];
};

export default useHover;
